import React from "react";
import { Spinner } from "reactstrap";
import { Box, Button, IconButton, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextField from "@mui/material/TextField";
import { UsernameSelectField } from "../../pages/MyTracks/styles";
import { EmailInviteTextField, useStyles } from "../../pages/MyTracks/styles";
import { styles } from "../../pages/MyTracks/styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { LightTooltip } from "../LightToolTip/LightToolTip";
import { batchTrackCollabDetailsStyles } from "./styles";
import { BatchTrackModalCollabDetailsProps } from "./types";
import { APP_BACKGROUND_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const BatchTrackModalCollabDetails: React.FC<
  BatchTrackModalCollabDetailsProps
> = ({
  showCollabTooltip,
  handleShowCollabTooltip,
  setShowCollabTooltip,
  collabVal,
  setCollabVal,
  usersList,
  collaborators,
  isSubmitting,
  currentUpload,
  values,
  removeCollaborator,
  addCollaborator,
  emailInvite,
  handleChangeInvites,
  handleCollabInvites,
  handleRemoveEmail,
  emailInviteList,
}) => {
  const classes = useStyles();
  return (
    <>
      <Box className="collab-label">
        <span>Add Collaborators </span>
        <span className="optional-input">(optional)</span>
        <Box
          style={{ display: "inline" }}
          onMouseOver={() => setShowCollabTooltip(true)}
          onMouseLeave={() => setShowCollabTooltip(false)}
        >
          <LightTooltip
            title="You can add artists, composers, and more collaborators"
            placement="top"
            open={showCollabTooltip}
            onClick={handleShowCollabTooltip}
          >
            <IconButton disableRipple>
              <HelpOutlineIcon color="info" style={{ height: 16, width: 16 }} />
            </IconButton>
          </LightTooltip>
        </Box>
      </Box>
      <hr />

      <Box sx={batchTrackCollabDetailsStyles.addCreatorsContainer}>
        <Box sx={{ width: "80%" }}>
          <label
            htmlFor="newCollaboratorUser"
            style={styles.modalCreatorUsername}
          >
            {"Creator's Username"}
          </label>
          <UsernameSelectField
            freeSolo
            forcePopupIcon={false}
            isOptionEqualToValue={(option, value) => option === value}
            inputValue={collabVal}
            onInputChange={(
              event: React.SyntheticEvent<Element, Event>,
              value: string
            ) => {
              setCollabVal(value);
            }}
            options={usersList.map((item) => item.getUsername()).sort()}
            renderInput={(params) => (
              <TextField
                style={{
                  backgroundColor: APP_BACKGROUND_COLOR,
                  color: TEXT_COLOR,
                }}
                {...params}
                label=" "
                InputLabelProps={{
                  shrink: false,
                }}
                classes={{ root: classes.customTextField }}
              />
            )}
            renderOption={(props, option: any) => (
              <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                {option}
              </li>
            )}
          />
        </Box>
        <Button
          disabled={collabVal === ""}
          sx={batchTrackCollabDetailsStyles.addButton}
          size="small"
          variant="contained"
          onClick={() => {
            if (!isSubmitting) {
              addCollaborator(collabVal);
            }
          }}
        >
          Add
        </Button>
      </Box>
      <Box className="collaborators" style={{ margin: "20px 0 40px" }}>
        <Box className="collaborators-target">
          {collaborators &&
            collaborators.length > 0 &&
            collaborators.map((collaborator, index) => (
              <Box className="collaborator" key={index}>
                <p
                  style={{
                    fontFamily: FONT_FAMILY,
                    flexGrow: 1,
                  }}
                >
                  {collaborator.getUsername()}
                </p>
                {!isSubmitting && (
                  <IconButton onClick={() => removeCollaborator(collaborator)}>
                    <DeleteForeverIcon />
                  </IconButton>
                )}
              </Box>
            ))}
        </Box>
      </Box>

      <div style={batchTrackCollabDetailsStyles.horizontalDiv} />
      <Box sx={batchTrackCollabDetailsStyles.inviteEmailContainer}>
        <Box sx={{ width: "80%" }}>
          <label htmlFor="emailInvite" style={styles.modalCreatorUsername}>
            {"Invite Collaborator"}
          </label>
          <EmailInviteTextField
            hiddenLabel
            variant="outlined"
            classes={{ root: classes.customTextField }}
            placeholder="Send an invite email to a collaborator"
            value={emailInvite}
            onChange={handleChangeInvites}
          />
        </Box>
        <Button
          disabled={emailInvite === ""}
          sx={batchTrackCollabDetailsStyles.addButton}
          size="small"
          variant="contained"
          onClick={handleCollabInvites}
        >
          Add
        </Button>
      </Box>

      <Box style={{ marginBottom: 10, width: "100%" }}>
        <Box>
          {emailInviteList &&
            emailInviteList.length > 0 &&
            emailInviteList.map((email, index) => (
              <Box
                className="collaborator"
                style={{ width: "100%" }}
                key={index}
              >
                <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>{email}</p>

                <IconButton onClick={() => handleRemoveEmail(email)}>
                  <DeleteForeverIcon />
                </IconButton>
              </Box>
            ))}
        </Box>
      </Box>
      <hr />
      <Button
        disabled={isSubmitting}
        fullWidth
        type="submit"
        sx={styles.modalSubmitButton}
        size="small"
        variant="contained"
      >
        {isSubmitting ? (
          <>
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              color="black"
            />{" "}
            <span style={batchTrackCollabDetailsStyles.uploadingSpan}>
              {currentUpload ? `Uploading ${currentUpload}` : `Uploading...`}
            </span>
          </>
        ) : (
          <Typography variant="h1" sx={styles.modalSubmitButtonText}>
            Add Tracks
          </Typography>
        )}
      </Button>
    </>
  );
};
